import { Fragment, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Stack, Typography } from "@mui/material";
import { HSApplicationForm } from "features/Homeschool";
import { Helmet } from "react-helmet-async";
import { trackMetaLead } from "services/meta.service";

export default function SignUpHomeSchoolPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referralCode = queryParams.get("referral_code");

  const buildUrlWithReferral = (path) => {
    if (referralCode) {
      return `${path}?referral_code=${referralCode}`;
    }
    return path;
  };

  useEffect(() => {
    if (window?.rdt != null) {
      window.rdt("track", "Lead");
    }
    if (window?.lintrk != null) {
      window.lintrk("track", { conversion_id: 26716844 });
    }
    trackMetaLead();
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>Sooth - Signup for Homeschool Access</title>
      </Helmet>
      <Stack
        direction="row"
        sx={({ palette }) => ({
          position: "absolute",
          top: 0,
          right: 0,
          left: 0,
          bgcolor: palette.secondary.main,
          p: 2,
          justifyContent: "end",
          alignItems: "center",
          gap: 2,
        })}
      >
        <Typography variant="body2">Not a homeschooler?</Typography>
        <Button
          LinkComponent={Link}
          to={buildUrlWithReferral("/signup")}
          color="primary"
        >
          Sign up
        </Button>
      </Stack>
      <Typography variant="h3">Homeschool Access</Typography>
      <Typography>
        Our platform does not allow sign-ups using generic emails (e.g. gmail,
        yahoo, icloud, proton, etc.) unless you can demonstrate you are a
        verified homeschooler who uses a generic email. Please fill out the
        information below only if you are a homeschooler and rely on a generic
        email. This form is only required if the student does not have a valid
        school email address. If the student does have a valid school email
        address (provided by the local school district), please sign-up using
        one of the other methods.
      </Typography>
      <HSApplicationForm referralCode={referralCode} />
    </Fragment>
  );
}
